// https://emailregex.com/
// Slightly modified to disallow quoted strings
export const EMAIL_REGEX =
  /^([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const cleanEmail = (email: string): string => {
  return email.trim().toLowerCase();
};

/**
 * Cleans and validates an email to check if it is valid
 * @param origEmail the email to clean and validate
 */
export const validateEmail = (origEmail: string): string => {
  const email = cleanEmail(origEmail);
  if (!EMAIL_REGEX.test(email)) {
    throw new Error("Not a valid email");
  }
  return email;
};

/**
 * Remove portion of email alias including and after the "+" up until the "@".
 */
export const stripPlusComponent = (email: string): string =>
  email.replace(/\+.+@/, "@");

export const SUPPORT_USER_EMAIL = "support@hex.tech";

export const getEmailDomain = (email: string): string => {
  return email.split("@").pop() ?? "";
};

export const isEduDomain = (domain: string): boolean => {
  // EDU domains can end with .edu (US only) or .edu.[country_code] (e.g. "example.edu.au")
  // Additionally, .ac.[country_code] (e.g. "example.ac.uk") also can point to educational institutions
  // There are other country specific emails that do not follow this pattern so this is not an exhaustive check.
  // To check this, we'd need to include special cases (e.g. .some_university.ca) which this function does not currently do

  const eduRegexp = /\.edu(\.[a-z]{2})?$/;
  const acRegexp = /\.ac\.([a-z]{2})?$/; // @[*].ac points to the Ascension Island, and can be a first level domain

  return eduRegexp.test(domain) || acRegexp.test(domain);
};

// These emails are used for customers that buy us directly through 3rd party vendors.
// We should not allow those organizations to see or update their emails.
export const EMAILS_THAT_SHOULD_NOT_BE_UPDATED = [
  "ar+snowflake@hex.tech",
  "ar+aws@hex.tech",
];
